// extracted by mini-css-extract-plugin
export default {"productGallery":"cP-z","inQuickShop":"dP-z"};